@if (checked) {
    <li class="list-group-item">
        <div class="d-flex align-items-center gap-1"><mat-icon class="text-success">check_circle</mat-icon>{{ text }}</div>
    </li>
}
@if (!checked) {
    <li class="list-group-item">
        <div class="d-flex align-items-center gap-1"><mat-icon class="text-danger">block</mat-icon> {{ text }}</div>
    </li>
}
